
Drupal.behaviors.effectGallery = {

  attach(context) {
    
    if (context !== document) {
      return;
    }

    const elements = context.querySelectorAll(
      'span.upceEffects--effect-gallery'
    );

    elements.forEach((element) => {
      effectGallery(element);
    });

    function effectGallery(element) {

      const effectGallery = new window.upceEffects(element);

      // console.log(effectGallery.element);
      // console.log(effectGallery.data);

      const images = effectGallery.element.querySelectorAll('img.image');
      const c = images.length;
      
      if (c > 1) { // mame k dispozici vice obrazku

        // gsap.set(images, {autoAlpha:1})
        const tl = gsap.timeline({}); // paused: true, repeat: 2, repeatDelay: 1

        images.forEach((image, i) => {

          if (i == 0) { // 1. prvek
            image.style.opacity = 1;
          } else {
            image.style.opacity = 0;
          }

          let j = i + 1;
          if (j == c) {
            j = 0;
          }

          tl.addLabel("image_" + (i + 1), "<"); // label pro pripadnou navigaci pomoci sipek (tl.seek('image_3');)
          tl.to(images[i], { opacity: 0, duration: effectGallery.data.duration }, "+=" + effectGallery.data.delay );
          tl.to(images[j], { opacity: 1, duration: effectGallery.data.duration }, '<');

        });

        // tl.play();
        // tl.seek('image_3');

      }

    }

  },

};